module.exports = __webpack_public_path__ + "static/media/Stephanie-G_160px.18e23a0c.jpg";